module.exports = __webpack_public_path__ + "static/pan_de_mallorca-778601bd39322f3e00c6a6756142ed00.jpg";